import { ControllerBaseLayout } from 'router/ControllerBaseLayout';
import React from 'react';
import { News, Topic } from 'pages/News';

export const newsRoutes = {
  path: 'news',
  children: [
    {
      path: ':id',
      element: (
        <ControllerBaseLayout bg="secondary" isHaveButtonBack>
          <Topic />
        </ControllerBaseLayout>
      ),
    },
    {
      index: true,
      element: (
        <ControllerBaseLayout isHaveButtonBack={false} bg="primary">
          <News />
        </ControllerBaseLayout>
      ),
    },
  ],
};
